import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';

const ManageAgencies = () => {
  const [agencies, setAgencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAgencies();
  }, []);

  const fetchAgencies = async () => {
    try {
      setLoading(true);
      
      const data = await apiService.get('/agencies');
      setAgencies(data);
      setError(null);
    } catch (err) {
      console.error('Error fetching agencies:', err);
      setError('Failed to load agencies. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const handleAgencyClick = (agencyId) => {
    // Navigate to agency details page when implemented
    navigate(`/agencies/${agencyId}`);
  };

  if (loading) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Manage Agencies</h1>
        </div>
        <div className="loading-state">
          <p>Loading agencies...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="manage-properties">
        <div className="page-header">
          <h1>Manage Agencies</h1>
        </div>
        <div className="error-state">
          <p>{error}</p>
          <button onClick={fetchAgencies} className="retry-button">
            Try Again
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="manage-properties">
      <div className="page-header">
        <h1>Manage Agencies</h1>
      </div>

      <div className="properties-table">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Agency Name</th>
              <th>Description</th>
              <th>Contact Person</th>
              <th>Contact Number</th>
              <th>Email</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {agencies.map((agency) => (
              <tr key={agency.id}>
                <td>
                  <strong>{agency.id}</strong>
                </td>
                <td>
                  <a 
                    href="#"
                    className="property-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handleAgencyClick(agency.id);
                    }}
                    title="Click to edit agency details"
                  >
                    {agency.agencyName}
                  </a>
                </td>
                <td>{agency.description}</td>
                <td>{agency.contactPerson}</td>
                <td>{agency.contactNumber}</td>
                <td>{agency.emailAddress}</td>
                <td>
                  <span className={`status-badge ${agency.isActive ? 'active' : 'inactive'}`}>
                    {agency.isActive ? 'Active' : 'Inactive'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageAgencies;
